import { useNavigate } from 'react-router-dom';

import { Alert, Box, Button, CircularProgress, TextField, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useStyles } from './styles';
import { emailRules } from '@shared/constants/validation.constants';
import { Controller } from 'react-hook-form';
import { useForgotPassword } from '../hook/useForgotPassword';
import { UnauthenticatedPath } from '@shared/constants/routes.constants';

export const ForgotPasswordForm = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { classes } = useStyles();
  const {
    onSubmit,
    control,
    errorMsg,
    successMSg,
    isLoading,
    formState: { errors },
  } = useForgotPassword();

  const handleBackBtn = () => {
    navigate(UnauthenticatedPath.SIGN_IN);
  };

  return (
    <Box className={classes.root} component="form" onSubmit={onSubmit}>
      <Box className={classes.header}>
        <Typography className={classes.title} variant="h3" component="h1">
          {t('forgot.forgotPassword.title')}
        </Typography>
        <Typography className={classes.description} component="div">
          {t('forgot.forgotPassword.description')}
        </Typography>
        {errorMsg && (
          <Alert severity="error" role="alert" aria-live="polite">
            {errorMsg}
          </Alert>
        )}
        {successMSg && (
          <Alert severity="success" role="status" aria-live="polite">
            {successMSg}
          </Alert>
        )}
      </Box>
      <Box className={classes.main}>
        <Box className={classes.field}>
          <Typography
            className={classes.fieldLabel}
            component="label"
            htmlFor="forgot-password-email">
            {t('forgot.forgotPassword.email')}
          </Typography>
          <Controller
            name="email"
            control={control}
            defaultValue=""
            rules={emailRules}
            render={({ field: { ref: _ref, ...fieldProps } }) => (
              <TextField
                className={classes.fieldInput}
                size="small"
                color="info"
                id="forgot-password-email"
                type="email"
                autoComplete="email"
                placeholder={t('forgot.forgotPassword.emailPlaceholder')}
                error={!!errors.email}
                helperText={errors.email ? errors.email.message : ' '}
                {...fieldProps}
              />
            )}
          />
        </Box>
      </Box>
      <Box className={classes.footer}>
        <Box className={classes.submit_btn}>
          <Button fullWidth variant="contained" type="submit" disabled={isLoading}>
            {isLoading ? (
              <CircularProgress
                size={20}
                color="inherit"
                aria-label={t('forgot.forgotPassword.loading')}
              />
            ) : successMSg ? (
              t('forgot.forgotPassword.sendAgain')
            ) : (
              t('forgot.forgotPassword.sendEmail')
            )}
          </Button>
        </Box>
        <Box className={classes.back_btn}>
          <Button fullWidth variant="contained" type="button" onClick={handleBackBtn}>
            {t('forgot.forgotPassword.backToSignIn')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};
